/*
 * Copyright (C) 2024 Jonathan Canevese - All Rights Reserved
 * This is copyrighted software
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential by Jonathan Canevese
 */

import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const useI18n = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const detectLanguage = async () => {
      // Check if language is already set in localStorage to avoid overwriting user preference
      const savedLanguage = localStorage.getItem("i18nextLng");
      if (savedLanguage) {
        return;
      }

      try {
        const response = await fetch(
          "https://pro.ip-api.com/json?key=133nVjso0R05Cna",
        );
        const data = await response.json();
        if (data.status === "success" && data.countryCode) {
          const detectedLang = data.countryCode === "IT" ? "it" : "en";
          i18n.changeLanguage(detectedLang);
        }
      } catch (error) {
        console.error("Failed to detect location:", error);
      }
    };

    detectLanguage();
  }, [i18n]);
};

export default useI18n;
